<template>
  <section class="page-content--bgf7">
    <section class="au-breadcrumb2">
      <div class="container m-b-20">
        <div class="row m-t-30">
          <div class="col-md-2">
            <h3 class="title-5">
              <i class="fas fa-list p-r-5" />
              Assets
            </h3>
          </div>
          <div class="col-md-8 text-overline">
            <span class="p-r-10 grey--text text--darken-1">
              Selected: {{ total }} / {{ tab === 3 ? totals.ads : totals.vod }}
            </span>
            <span class="p-l-10 p-r-10 green--text text--darken-1">
              Ready: {{ filteredCount.ready }}
            </span>
            <span class="p-r-10 grey--text text--darken-1">
              Pending: {{ filteredCount.pending }}
            </span>
            <span class="p-r-10 grey--text text--darken-1">
              Transcoding: {{ filteredCount.transcoding }}
            </span>
            <span
              class="p-r-10 grey--text text--darken-1"
              :class="{'error--text text--darken-2 font-weight-medium': filteredCount.issued > 0 }"
            >
              Issued: {{ filteredCount.issued }}
            </span>
            <span
              class="grey--text text--darken-1"
              :class="{'error--text text--darken-2 blinkable font-weight-medium': filteredCount.failed > 0 }"
            >
              <i
                v-if="filteredCount.failed > 0"
                class="fa fa-exclamation p-r-5"
              />
              Failed: {{ filteredCount.failed }}
            </span>
          </div>
          <div class="col-md-2 text-right">
            <v-btn
              outlined
              color="primary"
              @click="goToEditMeta()"
            >
              <i class="mdi mdi-pencil p-r-5" />
              Bulk Editor
            </v-btn>
          </div>
        </div>
        <v-tabs
          v-model="tab"
          @change="changeTab"
        >
          <v-tab>
            VOD ({{ totals.vod }})
          </v-tab>
          <v-tab disabled>
            TV Series ({{ totals.series }})
          </v-tab>
          <v-tab disabled>
            Packages ({{ totals.packages }})
          </v-tab>
          <v-tab :disabled="loading">
            Ads ({{ totals.ads }})
          </v-tab>
        </v-tabs>
        <v-card
          class="m-b-40"
          :loading="loading"
        >
          <v-divider class="ma-0 pa-0" />
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <div
                class="d-flex justify-space-between"
              >
                <span class="p-t-30 p-r-10 p-l-20">
                  Sort by:
                </span>
                <v-radio-group
                  v-model="sortby"
                  row
                  class="radios p-t-10"
                >
                  <v-radio
                    label="Time Added"
                    value="time"
                  />
                  <v-radio
                    label="Duration"
                    value="duration"
                  />
                </v-radio-group>

                <v-text-field
                  v-model.trim="filters.search"
                  label="Search by title"
                  hide-details
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  class="m-r-40"
                />

                <div class="d-flex justify-space-between">
                  <v-checkbox
                    v-model="filters.states"
                    class="checkboxes m-r-10"
                    label="Processing"
                    value="processing"
                    hide-details
                  />
                  <v-checkbox
                    v-model="filters.states"
                    class="checkboxes m-r-10"
                    label="Ready"
                    value="ready"
                    hide-details
                  />
                  <v-checkbox
                    v-model="filters.states"
                    class="checkboxes m-r-40"
                    label="Failed"
                    value="error"
                    hide-details
                  />
                </div>

                <v-btn
                  depressed
                  :disabled="loading"
                  color="primary"
                  class="m-t-15 m-r-40"
                  @click="applyFilters(false)"
                >
                  <v-icon left>
                    mdi-filter
                  </v-icon> Apply
                </v-btn>
              </div>

              <!--v-sheet
                style="min-height: 100px !important;"
                max-height="300"
                class="tags-block p-l-10"
              >
                <v-checkbox
                  v-for="tag in tags"
                  :key="tag.id"
                  v-model="filters.tags"
                  class="ma-0 pa-0 checkboxes"
                  :label="tag.name"
                  :value="tag.id"
                  hide-details
                />
              </v-sheet-->
              <div />
            </v-col>
            <v-col
              cols="12"
              md="12"
              class="p-t-0"
            >
              <v-card-text class="p-t-0">
                <div
                  v-if="loading"
                  class="el-loading-mask"
                >
                  <div class="el-loading-spinner">
                    <svg
                      viewBox="25 25 50 50"
                      class="circular"
                    >
                      <circle
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        class="path"
                      />
                    </svg>
                  </div>
                </div>
                <div class="table-responsive assets">
                  <table class="align-middle mb-0 table table-hover">
                    <thead>
                      <tr>
                        <th />
                        <th>Title</th>
                        <th><i class="mdi mdi-timer" /></th>
                        <th />
                        <th>Status</th>
                        <th>Added</th>
                        <th
                          v-if="assets.length"
                          class="checkbox"
                        >
                          <v-checkbox
                            v-model="allSelected"
                            hide-details
                            class="m-0 p-0"
                            @change="toggleSelected"
                          />
                        </th>
                      </tr>
                      <!--tr v-else>
                        <td
                          colspan="5"
                          class="text-right"
                        >
                          <v-btn
                            depressed
                            color="error"
                            class="ma-0"
                            @click="assetsRemoveDialog=true"
                          >
                            Delete selected ({{ selected.length }})
                          </v-btn>
                        </td>
                        <th class="checkbox">
                          <v-checkbox
                            v-model="allSelected"
                            hide-details
                            class="m-0 p-0"
                            :indeterminate="selected.length !== assets.length"
                            @change="toggleAll"
                          />
                        </th>
                      </tr-->
                    </thead>
                    <tbody>
                      <tr
                        v-for="(asset, i) of assets"
                        :key="asset.id"
                        @mouseover="setActiveRow(i)"
                        @mouseleave="setActiveRow(-1)"
                      >
                        <td
                          style="width: 300px;"
                          @click="showAssetDetail(asset.id)"
                        >
                          <div
                            v-if="asset.streams.length"
                            class="d-flex justify-space-between"
                          >
                            <v-img
                              v-if="!asset.streams[0].screenshotted"
                              width="100"
                              height="67"
                              :src="asset.posterId ? '/api/v1/upload/' + asset.posterId + '?img.crop=100x67' : defaultPoster"
                              class="card m-r-10"
                              style="border: 2px solid #1975d2;"
                            />
                            <v-img
                              width="100"
                              height="67"
                              :src="asset.streams[0].streamURL.replace('playlist.m3u8', '01.jpg')"
                              class="card"
                            />
                            <v-img
                              width="100"
                              height="67"
                              :src="asset.streams[0].streamURL.replace('playlist.m3u8', '02.jpg')"
                              class="card"
                            />
                            <v-img
                              width="100"
                              height="67"
                              :src="asset.streams[0].streamURL.replace('playlist.m3u8', '03.jpg')"
                              class="card"
                            />
                          </div>
                        </td>
                        <td
                          class="text-body-1"
                          @click="showAssetDetail(asset.id)"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                              >
                                {{ asset.name | truncate(55) }}
                              </span>
                            </template>
                            {{ asset.name || 'N/A' }}
                          </v-tooltip>
                          <br>
                          <span
                            v-for="tag in asset.tags.slice(0, 2)"
                            :key="'tag'+tag.id"
                            class="grey--text text-body-2 text--lighten-1 p-r-10"
                            :class="{'text--darken-2': activeRow === i }"
                          >
                            {{ tag.name }}
                          </span>
                        </td>
                        <td>
                          <span v-if="['ready'].includes(asset.state)">
                            {{ Math.round(asset.duration/60) || '&lt;1' }}'
                          </span>
                        </td>
                        <td
                          v-if="asset.streams.length"
                          class="checkbox"
                        >
                          <v-btn
                            v-if="asset.streams.length"
                            class="mx-2 shadow-none orange darken-1"
                            fab
                            dark
                            x-small
                            @click.prevent="openPlayer(asset.streams[0].streamURL)"
                          >
                            <v-icon>mdi-play</v-icon>
                          </v-btn>
                        </td>
                        <td
                          class="text-body-1"
                          style="width: 110px;"
                          @click="showAssetDetail(asset.id)"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <div
                                class="status text-body-1 tc-green-900 bgc-green-100 m-r-5"
                                v-on="on"
                              >
                                C
                              </div>
                            </template>
                            Created
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <div
                                class="status text-body-1"
                                :class="{
                                  'tc-green-900 bgc-green-100': ['ready'].includes(asset.state),
                                  'tc-amber-800 transcoding-pulse-animation': ['transcoding'].includes(asset.state),
                                  'tc-red-600 bgc-red-100 no-padding': asset.state === 'issued' || asset.state === 'error',
                                }"
                                v-on="on"
                              >
                                <span v-if="asset.state === 'issued'">
                                  <i class="mdi mdi-alert-circle-outline" />
                                </span>
                                <span v-else-if="asset.state === 'error'">
                                  <i class="mdi mdi-close-circle-outline" />
                                </span>
                                <span v-else>T</span>
                              </div>
                            </template>
                            <span class="text-capitalize">{{ asset.state }}</span>
                          </v-tooltip>
                        </td>
                        <td
                          class="text-body-1"
                          style="width: 120px;"
                          @click="showAssetDetail(asset.id)"
                        >
                          {{ moment.utc(asset.createTime).format('D MMM YY') }}
                        </td>
                        <td class="checkbox">
                          <v-checkbox
                            :key="asset.id"
                            v-model="selected"
                            hide-details
                            :value="asset.id"
                            class="m-0 p-0"
                          />
                        </td>
                      </tr>
                      <tr
                        v-if="!loading && !assets.length"
                        class="no-hover notclickable"
                      >
                        <td
                          class="text-center notclickable"
                          colspan="6"
                        >
                          <div class="m-b-30 m-t-30">
                            No data
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  v-show="totalPages > 1"
                  class="text-center p-t-10"
                >
                  <v-pagination
                    v-model="page"
                    :length="totalPages"
                    :total-visible="7"
                  />
                </div>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>

        <!-- assets Remove Dialog -->
        <v-dialog
          v-model="assetsRemoveDialog"
          max-width="500"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5">
              Delete assets?
            </v-card-title>
            <v-card-text>
              <div class="row p-b-20">
                <div class="col-md-12">
                  Are you sure you want to delete the following assets:
                </div>
                <v-sheet
                  max-height="300"
                >
                  <ul class="selected-assets">
                    <li
                      v-for="id in selected"
                      :key="`r`+id"
                    >
                      {{ selectedMap[id] }}
                    </li>
                  </ul>
                </v-sheet>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                depressed
                text
                @click="assetsRemoveDialog = false"
              >
                No
              </v-btn>
              <v-btn
                depressed
                :loading="removing"
                color="error"
                @click="deleteSelectedAssets()"
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Single Asset Remove Dialog -->
        <v-dialog
          v-model="assetRemoveDialog"
          max-width="500"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5">
              Delete asset?
            </v-card-title>
            <v-card-text>
              <div class="row p-b-20">
                <div class="col-md-12">
                  Are you sure you want to delete the asset {{ deletedAsset.name }}?
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                depressed
                small
                text
                @click="assetRemoveDialog = false"
              >
                No
              </v-btn>
              <v-btn
                depressed
                small
                color="error"
                @click="deleteAsset()"
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </section>
    <v-snackbar
      :value="selected.length"
      timeout="-1"
    >
      Selected items: {{ selected.length }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="selected = []"
        >
          reset
        </v-btn>
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="removeAssets"
        >
          Delete
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      :persistent="false"
      inset
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </section>
</template>

<script>
  import Vue from 'vue'
  import { sleep } from '@/helpers/utils'
  import { assetToJsonAPI, processAsset, processTag } from '@/store/converters'

  export default {
    data () {
      return {
        channel: {},
        tab: 0,
        totals: {
          vod: 0,
          series: 0,
          packages: 0,
          ads: 0,
        },
        filteredCount: {
          pending: 0,
          transcoding: 0,
          issued: 0,
          failed: 0,
          ready: 0,
        },
        page: 1,
        tags: [],
        states: ['processing', 'ready', 'issued', 'error'],
        filters: {
          tags: [],
          states: [],
          search: '',
        },
        selectedFilters: {
          tags: [],
          states: [],
          search: '',
        },
        added: 'all',
        period: {
          startDate: '',
          startDateMenu: '',
          endDate: '',
          endDateMenu: '',
        },
        activeRow: -1,
        limit: 20,
        offset: 0,
        total: 0,
        allSelected: false,
        selectedMap: {},
        selected: [],
        polling: null,
        assetsRemoveDialog: false,
        assetRemoveDialog: false,
        removing: false,
        deletedAsset: {},
        assets: [],
        sortby: 'time',
        frameSrc: '',
        playerDialog: false,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      totalPages () {
        return Math.ceil(this.total / this.limit)
      },
      defaultPoster () {
        return '/images/no-image-black.png'
      },
    },
    watch: {
      // eslint-disable-next-line no-unused-vars
      selected (newVal, oldVal) {
        this.checkAllSelected()
        /*        if (newVal.length === 0) {
          this.allSelected = false
        } else this.allSelected = newVal.length === this.assets.length */
      },
      page (newVal, oldVal) {
        if (newVal !== oldVal) {
          // this.allSelected = false
          // this.selected = []
          this.page = newVal
          this.changeRoute()
          this.getAssets(false)
        }
      },
    },
    created () {
      this.channel.id = this.$route.params.id

      this.loadData(false)
      this.pollData()
      this.setFrameSrc('')
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      checkAllSelected () {
        const selectedMap = {}
        for (let i = 0; i < this.selected.length; i += 1) {
          selectedMap[this.selected[i]] = true
        }

        for (let i = 0; i < this.assets.length; i += 1) {
          // eslint-disable-next-line no-prototype-builtins
          if (!selectedMap.hasOwnProperty(this.assets[i].id)) {
            this.allSelected = false
            return
          }
        }
        this.allSelected = true
      },
      toggleSelected (checked) {
        const selectedMap = {}
        for (let i = 0; i < this.selected.length; i += 1) {
          selectedMap[this.selected[i]] = true
        }
        if (checked) {
          for (let i = 0; i < this.assets.length; i += 1) {
            // eslint-disable-next-line no-prototype-builtins
            if (!selectedMap.hasOwnProperty(this.assets[i].id)) {
              this.selected.push(this.assets[i].id)
            }
          }
        } else {
          for (let i = 0; i < this.assets.length; i += 1) {
            // eslint-disable-next-line no-prototype-builtins
            if (selectedMap.hasOwnProperty(this.assets[i].id)) {
              delete selectedMap[this.assets[i].id]
            }
          }
          const newSelected = []
          for (const id in selectedMap) {
            newSelected.push(id)
          }
          this.selected = newSelected
        }
      },
      changeTab () {
        this.page = 1
        this.changeRoute()
        this.getAssets(false)
      },
      parseFilters () {
        const { tab } = this.$route.query
        if (tab) {
          const t = Number(tab)
          this.tab = t < 0 || t > 3 ? 0 : t
        }

        let page = Number(this.$route.query.page)
        if (!page) {
          page = 1
        }
        this.page = page

        const { states } = this.$route.query
        if (states) {
          const statesArr = states.split(',')
          const unique = {}
          for (let i = 0; i < statesArr.length; i += 1) {
            const state = statesArr[i]
            // eslint-disable-next-line no-prototype-builtins
            if (this.states.includes(state) && !unique.hasOwnProperty(state)) {
              this.filters.states.push(state)
              unique[state] = 1
            }
          }
        } else {
          for (let i = 0; i < this.states.length; i += 1) {
            const state = this.states[i]
            this.filters.states.push(state)
          }
        }
        const { tags } = this.$route.query
        if (tags) {
          const tagsArr = tags.split(',')
          const unique = {}
          const existingTags = {}
          for (let i = 0; i < this.tags.length; i += 1) {
            const tag = this.tags[i]
            existingTags[tag.id] = tag
          }
          for (let i = 0; i < tagsArr.length; i += 1) {
            const tagId = Number(tagsArr[i])
            // eslint-disable-next-line no-prototype-builtins
            if (existingTags.hasOwnProperty(tagId) && !unique.hasOwnProperty(tagId)) {
              this.filters.tags.push(tagId)
              unique[tagId] = 1
            }
          }
        }
        const { search } = this.$route.query
        if (search) {
          this.filters.search = search
        }
      },
      pollData () {
        this.polling = setInterval(() => {
          if (!this.loading) {
            this.getAssets(true)
          }
        }, 10000)
      },
      loadData (silent) {
        if (this.loading) return

        if (!silent) {
          this.$store.commit('setPageLoader')
        }

        const args = {
          'channel.id[eq]': this.channel.id,
        }
        const tagReq = this.$store.dispatch('tags', args)

        // eslint-disable-next-line consistent-return
        Promise.all([tagReq])
          .then((res) => {
            const tags = res[0]
            this.tags = tags.map((t) => processTag(t))
            this.parseFilters()
            this.addFilters()
            this.changeRoute()
            this.getAssets(false)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({
              name: 'DashboardPage',
            })
          })

        const totalMovieArgs = {
          'type[eq]': 'movie',
          'channel.id[eq]': this.channel.id,
        }
        const totalMovieReq = this.$store.dispatch('assetCount', totalMovieArgs)
        const totalAdArgs = {
          'type[eq]': 'ad',
          'channel.id[eq]': this.channel.id,
        }
        const totalAdReq = this.$store.dispatch('assetCount', totalAdArgs)

        // eslint-disable-next-line consistent-return
        return Promise.all([totalMovieReq, totalAdReq])
          .then((res) => {
            // eslint-disable-next-line prefer-destructuring
            this.totals.vod = res[0]
            // eslint-disable-next-line prefer-destructuring
            this.totals.ads = res[1]
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      getAssets (silent = false) {
        if (!silent) this.$store.commit('setPageLoader')

        const assetArgs = {
          $expand: 'tags,pictures,streams',
          $limit: this.limit,
          $offset: this.limit * this.page - this.limit,
          $orderby: '-id',
          'type[eq]': 'movie',
          'channel.id[eq]': this.channel.id,
        }

        const assetCountArgs = {
          'type[eq]': 'movie',
          'channel.id[eq]': this.channel.id,
        }
        const assetPendingArgs = {
          'type[eq]': 'movie',
          'state[eq]': 'pending',
          'channel.id[eq]': this.channel.id,
        }

        if (this.tab === 3) {
          assetArgs['type[eq]'] = 'ad'
          assetCountArgs['type[eq]'] = 'ad'
          assetPendingArgs['type[eq]'] = 'ad'
        }

        if (this.selectedFilters.tags.length) {
          assetArgs['tags.id[in]'] = this.selectedFilters.tags.join(',')
          assetCountArgs['tags.id[in]'] = this.selectedFilters.tags.join(',')
          assetPendingArgs['tags.id[in]'] = this.selectedFilters.tags.join(',')
        }
        if (this.selectedFilters.states.length) {
          assetArgs['state[in]'] = this.selectedFilters.states.join(',')
          assetCountArgs['state[in]'] = this.selectedFilters.states.join(',')
        }
        if (this.selectedFilters.search) {
          assetArgs.$match = this.selectedFilters.search
          assetCountArgs.$match = this.selectedFilters.search
          assetPendingArgs.$match = this.selectedFilters.search
        }

        if (this.sortby === 'duration') {
          assetArgs.$orderby = 'duration'
        }

        const assetReq = this.$store.dispatch('assets', assetArgs)
        const assetCountReq = this.$store.dispatch('assetCount', assetCountArgs)
        //
        const assetTranscodingArgs = JSON.parse(JSON.stringify(assetPendingArgs))
        assetTranscodingArgs['state[eq]'] = 'transcoding'

        const assetIssuedArgs = JSON.parse(JSON.stringify(assetPendingArgs))
        assetIssuedArgs['state[eq]'] = 'issued'

        const assetErrorArgs = JSON.parse(JSON.stringify(assetPendingArgs))
        assetErrorArgs['state[eq]'] = 'error'

        const assetReadyArgs = JSON.parse(JSON.stringify(assetPendingArgs))
        assetReadyArgs['state[eq]'] = 'ready'

        const assetPedningCountReq = this.$store.dispatch('assetCount', assetPendingArgs)
        const assetTranscodingCountReq = this.$store.dispatch('assetCount', assetTranscodingArgs)
        const assetIssuedCountReq = this.$store.dispatch('assetCount', assetIssuedArgs)
        const assetErrorCountReq = this.$store.dispatch('assetCount', assetErrorArgs)
        const assetReadyCountReq = this.$store.dispatch('assetCount', assetReadyArgs)

        // eslint-disable-next-line consistent-return,max-len
        return Promise.all([assetReq, assetCountReq, assetPedningCountReq, assetTranscodingCountReq, assetIssuedCountReq, assetErrorCountReq, assetReadyCountReq])
          .then((res) => {
            const assets = res[0]
            this.assets = assets.map((a) => processAsset(a))

            for (let i = 0; i < this.assets.length; i += 1) {
              this.selectedMap[this.assets[i].id] = this.assets[i].name
            }

            // eslint-disable-next-line prefer-destructuring
            this.total = res[1]
            // eslint-disable-next-line prefer-destructuring
            this.filteredCount.pending = res[2]
            // eslint-disable-next-line prefer-destructuring
            this.filteredCount.transcoding = res[3]
            // eslint-disable-next-line prefer-destructuring
            this.filteredCount.issued = res[4]
            // eslint-disable-next-line prefer-destructuring
            this.filteredCount.failed = res[5]
            // eslint-disable-next-line prefer-destructuring
            this.filteredCount.ready = res[6]

            this.checkAllSelected()
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      applyFilters (silent) {
        this.page = 1
        this.addFilters()
        this.changeRoute()
        this.getAssets(silent)
      },
      addFilters () {
        this.selectedFilters.states = []
        for (let i = 0; i < this.filters.states.length; i += 1) {
          const state = this.filters.states[i]
          if (state === 'processing') {
            this.selectedFilters.states.push('pending')
            this.selectedFilters.states.push('transcoding')
          } else {
            this.selectedFilters.states.push(state)
          }
        }
        this.selectedFilters.tags = []
        for (let i = 0; i < this.filters.tags.length; i += 1) {
          const tagId = this.filters.tags[i]
          this.selectedFilters.tags.push(tagId)
        }
        this.selectedFilters.search = ''
        if (this.filters.search) {
          this.selectedFilters.search = this.filters.search
        }
      },
      setActiveRow (i) {
        this.activeRow = i
      },
      showAssetDetail (id) {
        this.$router.push({
          name: 'AssetDetailPage',
          params: {
            id: this.$route.params.id,
            asset_id: id,
          },
        })
      },
      updateRoute (page) {
        if (Number(this.$route.query.page) === Number(page)) return
        const query = { ...this.$route.query, page }
        this.$router.push({ query }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      openDeleteAssetDialog (job) {
        this.deletedAsset = Vue.util.extend({}, job)
        this.assetRemoveDialog = true
      },
      deleteAsset () {
        const preparedAsset = assetToJsonAPI(this.deletedAsset)

        if (!preparedAsset.id) return

        this.$store.dispatch('removeAsset', preparedAsset)
          .then(() => {
            this.$toasted.success('The asset has been successfully removed', {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 5000,
            })
            this.loadData(true)
            for (let i = 0; i < this.selected.length; i += 1) {
              if (this.selected[i] === preparedAsset.id) {
                this.selected.splice(i, 1)
              }
            }
            this.deletedAsset = {}
            this.assetRemoveDialog = false
          })
          .catch((errorMsg) => {
            this.assetRemoveDialog = false
            this.$toasted.error(errorMsg, {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 7000,
            })
          })
      },
      removeAssets () {
        this.assetsRemoveDialog = true
      },
      deleteSelectedAssets () {
        if (this.selected.length === 0) return

        this.removing = true

        this.$store.dispatch('removeAssets', this.selected)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The assets have been successfully removed',
              timeout: 6000,
              color: 'success',
            })
            this.selected = []
            this.assetsRemoveDialog = false
            this.removing = false
            sleep(500).then(() => {
              this.loadData(true, true)
            })
            this.$store.dispatch('clearSchedule', { channel_id: this.channel.id })
              .then(() => {})
              .catch((errorMsg) => {
                console.log('error clearing schedule', errorMsg)
              })
          })
          .catch((errorMsg) => {
            this.assetsRemoveDialog = false
            this.selected = []
            this.removing = false
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      changeRoute () {
        const newQuery = {
          page: `${this.page}`,
          tab: `${this.tab}`,
        }
        if (this.selectedFilters.states.length) {
          const states = []
          const statesMap = {}
          for (let i = 0; i < this.selectedFilters.states.length; i += 1) {
            const state = this.selectedFilters.states[i]
            if (state === 'pending' || state === 'transcoding') {
              // eslint-disable-next-line no-prototype-builtins
              if (!statesMap.hasOwnProperty(state)) {
                states.push('processing')
                statesMap[state] = true
              }
            } else {
              // eslint-disable-next-line no-prototype-builtins
              if (!statesMap.hasOwnProperty(state)) {
                states.push(state)
                statesMap[state] = true
              }
            }
          }
          newQuery.states = states.sort().join(',')
        }
        if (this.filters.search) {
          newQuery.search = this.selectedFilters.search
        }
        if (this.selectedFilters.tags.length) {
          newQuery.tags = this.selectedFilters.tags.sort().join(',')
        }
        if (JSON.stringify(this.$route.query) === JSON.stringify(newQuery)) return
        this.$router.push({
          query: newQuery,
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      createPackage () {
        this.$router.push({
          name: 'PackageCreatePage',
        })
      },
      openPlayer (stream) {
        this.setFrameSrc(stream)
        this.playerDialog = true
      },
      setFrameSrc (url) {
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index2.html?src=${link}`
      },
      closePlayer () {
        this.playerDialog = false
        this.setFrameSrc('')
      },
      goToEditMeta (distribution) {
        this.$router.push({
          name: 'EditMeta',
        })
      },
    },
  }
</script>

<style>
  .checkboxes.v-input .v-label {
    margin-bottom: 0 !important;
  }
  .radios .v-label {
    margin: 0 !important;
  }
  .added .v-input__slot {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .no-padding {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .blinkable {
    animation: blinker 2s linear infinite;
  }

  @keyframes blinker {
    50% {
      opacity: 0.4;
    }
  }
  .selected-assets {
    height: 300px;
    position: relative;
    overflow-y: auto;
    width: 450px;
  }
</style>
